import { render, staticRenderFns } from "./VersionQuery.vue?vue&type=template&id=524ef826&"
import script from "./VersionQuery.vue?vue&type=script&lang=js&"
export * from "./VersionQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports